// TypeaheadSelect — قائمة منسدلة ببحث-بالكتابة لخيارات ثابتة (3.4.6).
// بديل خفيف عن <TextField select> للقوائم الطويلة (مُلّاك/سلالات/ألوان/دول…): نفس
// عقد القيمة (value/onChange بقيمة بسيطة) لكن مع فلترة فورية بالكتابة. الخيارات إمّا
// [{ value, label }] أو مصفوفة نصوص. آمن للاستبدال المباشر في النماذج.
import React, { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';

export default function TypeaheadSelect({
  options = [],
  value,
  onChange,
  label,
  size = 'small',
  fullWidth = true,
  disabled = false,
  required = false,
  error = false,
  helperText,
  placeholder,
  sx,
  ...rest
}) {
  const norm = useMemo(
    () => options.map((o) => (o && typeof o === 'object' ? o : { value: o, label: String(o) })),
    [options],
  );
  const selected = useMemo(
    () => norm.find((o) => String(o.value) === String(value)) ?? null,
    [norm, value],
  );

  return (
    <Autocomplete
      options={norm}
      value={selected}
      disabled={disabled}
      size={size}
      fullWidth={fullWidth}
      sx={sx}
      onChange={(_, v) => onChange(v ? v.value : '')}
      getOptionLabel={(o) => (o && o.label != null ? String(o.label) : '')}
      isOptionEqualToValue={(a, b) => String(a.value) === String(b.value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error}
          helperText={helperText}
          placeholder={placeholder}
        />
      )}
      {...rest}
    />
  );
}
